import { createContext } from 'react';
import { Schedule } from 'store/schedules/interfaces';
import { PreviewScheduleRange } from '../convertScheduleRanges';

export interface SchedulePreviewCalendarContextProps {
  scheduleRanges: PreviewScheduleRange[];
  schedule: Schedule;
}

export const SchedulePreviewCalendarContext = createContext<
  SchedulePreviewCalendarContextProps | undefined
>(undefined);
